module.exports = __webpack_public_path__ + "media/components/spaces/ask-question-sidebar-panel-1-98f73072e2921cdb8aafb1c226720ff9.png";